import { queryFilter, type RowFilter } from '../domain/rowFilter.js';
import { useTRPC } from '../utils/trpc.js';
import { CURSOR_PAGING, PAGE_SIZE, usePagedRows } from './usePagedRows.js';

/**
 * The Studios page's rows, 50 at a time. Mirrors `hooks/useGameRows.ts`'s shape, so the two
 * pages' fetching reads the same way — both built on `usePagedRows`. Also used by the Games
 * page's `StudioRail`, which needs the same rows filtered to nothing but its own search box.
 */
export const useStudioRows = (filter: RowFilter) => {
    const trpc = useTRPC();
    return usePagedRows(
        trpc.studios.list.infiniteQueryOptions({ limit: PAGE_SIZE, ...queryFilter(filter) }, CURSOR_PAGING),
    );
};
